import React from 'react';
import { cn } from '../../lib/utils';

interface DropdownContentProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean | { x?: number | string; y?: number | string };
  maxHeight?: number | string;
  minWidth?: number | string;
}

export function DropdownContent({
  children,
  className = '',
  padding = false,
  maxHeight = '80vh',
  minWidth,
}: DropdownContentProps) {
  // Handle padding options
  const getPaddingClasses = () => {
    if (padding === false) return ''; // No padding by default
    if (padding === true) return 'px-2'; // Horizontal padding only

    // Custom padding
    const { x, y } = padding;
    let classes = '';

    if (x) classes += typeof x === 'number' ? ` px-${x}` : ` px-[${x}]`;
    if (y) classes += typeof y === 'number' ? ` py-${y}` : ` py-[${y}]`;

    return classes;
  };

  const style: React.CSSProperties = {
    maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,
  };

  if (minWidth) {
    style.minWidth = typeof minWidth === 'number' ? `${minWidth}px` : minWidth;
  }

  return (
    <div className={cn('overflow-y-auto', getPaddingClasses(), className)} style={style}>
      {children}
    </div>
  );
}
